import styled, { css } from 'styled-components';
import { TextAlignment } from '../../../enum/EnumRepository';
import { getAlignment } from '../textarea/TextAreaBody';

// Naming convention:
// Do not naming when it used for
// Do naming explain their characteristics
// Do not setting position value. why? position is depends in situation.
// Do not setting width here. why? width is depends in situation.

const commonInputStyles = css`
  width: 100%;
  height: fit-content;
  background: transparent;
  border: none;
  outline: none;
  border-radius: 0px;
  &:focus {
    outline: none;
  }
`;

const smallPadding = css`
  padding: 2px 0px;
`;
const normalPadding = css`
  padding: 4px 0px;
`;

const normalPaddingWithLimit = css`
  padding-bottom: 4px;
  margin-top: 14px;
`;

const borderBottomContrast = css`
  color: ${({ theme }) => theme.colors.color_Gray_01};
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_06};
`;

const borderBottom = css`
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
  color: ${({ theme }) => theme.colors.color_Gray_03};
`;
const borderBottomLight = css`
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_05};
  color: ${({ theme }) => theme.colors.color_Gray_04};
`;


export const NormalInput = styled.input`
  ${commonInputStyles}
  ${normalPadding}
  ${borderBottom}
  ${({ theme }) => theme.typography.Body_03_2};
`;

export const InputWork = styled.input`
  ${commonInputStyles}
  ${smallPadding}
  ${borderBottom}
  text-align: center;
  ${({ theme }) => theme.typography.Body_04};
`;

export const InputWorkTitle = styled.input`
  ${commonInputStyles}
  ${borderBottom}
  text-align: center;
  font-style: oblique;
  ${({ theme }) => theme.typography.Body_02_2};
`;
export const InputPEDetailInfo = styled.input<{ $alignment: TextAlignment }>`
  ${commonInputStyles}
  ${normalPaddingWithLimit}
  ${borderBottom}
  text-align: ${({ $alignment }) => getAlignment($alignment)};
  ${({ theme }) => theme.typography.Body_04};
`;
export const InputPEPdfFileName = styled.input<{ $alignment: TextAlignment }>`
  ${commonInputStyles}
  ${smallPadding}
  ${borderBottom}
  text-align: ${({ $alignment }) => getAlignment($alignment)};
  ${({ theme }) => theme.typography.Body_03_2};
`;

export const InputTitle = styled.input`
  ${commonInputStyles}
  ${borderBottomContrast}
  ${({ theme }) => theme.typography.H_03};
`;

export const WorkViewerTitle = styled.input`
  ${commonInputStyles}
  height: fit-content;
  min-height: 28px;
  ${smallPadding}
  ${borderBottom}
  margin-bottom: 12px;
  ${({ theme }) => theme.typography.Body_03_2};
`;

export const MemberTitleInput = styled.input`
  ${commonInputStyles}
  ${normalPadding}
  ${borderBottom}
  ${({ theme }) => theme.typography.Body_02_1};
`;

export const MemberInfoValue = styled.input`
  ${commonInputStyles}
  ${smallPadding}
  ${borderBottom}
  ${({ theme }) => theme.typography.Body_04};
`;

export const MemberInfoValueMobile = styled.input`
  ${commonInputStyles}
  ${normalPadding}
  ${borderBottom}
  ${({ theme }) => theme.typography.Body_04};
`;

export const WorkViewerInfo = styled.input`
  ${commonInputStyles}
  ${normalPadding}
  ${borderBottom}
  ${({ theme }) => theme.typography.Body_04};
`;

export const PIInput = styled.input`
  ${commonInputStyles}
  ${normalPaddingWithLimit}
  ${borderBottomLight}
  ${({ theme }) => theme.typography.Body_03_2};
`;

export const WorkDetailInputDescription = styled.input`
  ${commonInputStyles}
  ${normalPaddingWithLimit}
  ${borderBottomLight}
  ${({ theme }) => theme.typography.Body_03_2};
`;

export const ContactInput = styled.input`
  ${commonInputStyles}
  ${smallPadding}
  ${borderBottomLight}
  ${({ theme }) => theme.typography.Body_04};
`;

const commonInputBoxStyles = css`
  padding: 10px;
  background: transparent;
  border-radius: 0px;
  outline: none;
  &:focus {
    outline: none;
  }
`;

// SearchBar에서 사용
export const SearchBox = styled.input`
  ${commonInputBoxStyles}
  padding: 4px 0;
  width: 100%;
  border: none;
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.color_Gray_04};
  ${({ theme }) => theme.typography.Body_04};
`;

// OnBoarding Step1, Step2에서 사용
export const InputBox = styled.input`
  ${commonInputBoxStyles}
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.color_Gray_05};
  background-color: ${({ theme }) => theme.colors.color_Gray_06};
  ${({ theme }) => theme.typography.Body_02_2};
`;

export const InputAuth = styled.input`
  ${commonInputBoxStyles}
  width: 100%;
  color: ${({ theme }) => theme.colors.color_Gray_01};
  border: 1px solid ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Body_02_2};
`;

export const InputAuthMobile = styled.input`
  ${commonInputBoxStyles}
  width: 100%;
  color: ${({ theme }) => theme.colors.color_Gray_01};
  border: 1px solid ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Body_03_2};
  
`;

export const InputPayment = styled.input`
  ${commonInputBoxStyles}
  width: 100%;
  color: ${({ theme }) => theme.colors.color_Gray_01};
  border: 1px solid ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Body_03_1};
`;